'use strict';

var userAgent = require('../internals/environment-user-agent');
module.exports = /web0s(?!.*chrome)/i.test(userAgent);